import { useEffect, useState } from 'react';
import { ZephrAccessDetails } from '@/common/zephr';

export const useZephrAccessDetails = () => {
  const [accessDetails, setAccessDetails] = useState<ZephrAccessDetails>();

  useEffect(() => {
    setAccessDetails(window['Zephr']?.accessDetails);
  }, []);

  return accessDetails;
};
